import React from 'react';
import { View, StyleSheet } from 'react-native';
import { colors } from '@/styles/colors';

interface ProgressBarProps {
  strength: number; // 0-100
  hasError: boolean;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ strength, hasError }) => {
  return (
    <View style={styles.container}>
      <View
        style={[
          styles.bar,
          {
            width: `${strength}%`,
            backgroundColor: hasError ? colors.warning : colors.success,
          },
        ]}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    height: 8,
    width: '100%',
    backgroundColor: '#E5E7EB',
    borderRadius: 4,
    overflow: 'hidden',
    marginTop: 8,
  },
  bar: {
    height: '100%',
    borderRadius: 4,
  },
});
